module.exports = __webpack_public_path__ + "img/disp.b32fc4f5.png";